export function CountWords(content) {
    if (content === undefined || content == null || content === "") {
        return 0;
    } else {
        return content.trim().replace(/\s+/gi, ' ').split(' ').length;
    }
}